module.exports = {"350902001":"蕉南街道","350902002":"蕉北街道","350902100":"城南镇","350902101":"漳湾镇","350902102":"七都镇","350902103":"八都镇","350902104":"九都镇","350902105":"霍童镇","350902106":"赤溪镇","350902107":"洋中镇","350902108":"飞鸾镇","350902109":"三都镇","350902110":"虎贝镇","350902200":"金涵畲族乡","350902201":"洪口乡","350902202":"石后乡","350902500":"东侨开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350902.json
// module id = 1237
// module chunks = 0